// removed by extract-text-webpack-plugin
module.exports = {"review":"review__1flJV","quote":"quote__1jQ6S","name":"name__kGjQN","designation":"designation__Vl53V"};


//////////////////
// WEBPACK FOOTER
// ./styles/plan/review.scss
// module id = 748
// module chunks = 68